// Removes not-buyable (discontinued) products from the cart.
(function () {
  const SOURCE = 'mx-not-buyable';

  const collectKeysFromDom = () => Array.from(
    document.querySelectorAll('.cart-item[data-not-buyable="true"]')
  )
    .map(row => row.dataset.key || row.dataset.variantId)
    .filter(Boolean);

  const refreshCartIcon = async () => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    try {
      const response = await fetch('?sections=cart-icon-bubble');
      if (!response.ok) return;
      const sections = await response.json();
      const html = sections['cart-icon-bubble'];
      if (typeof html !== 'string') return;

      const holder = document.createElement('div');
      holder.insertAdjacentHTML('beforeend', html);
      const fresh = holder.querySelector('.shopify-section') || holder;
      const target = bubble.querySelector('.shopify-section') || bubble;

      while (target.firstChild) target.removeChild(target.firstChild);
      while (fresh.firstChild) target.appendChild(fresh.firstChild);
    } catch (error) {
      console.error('Failed to refresh the cart count:', error);
    }
  };

  const refresh = async () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      await cartDrawer.refresh(true);
      return;
    }
    if (window.location.pathname === window.theme?.routes?.cart) {
      window.location.reload();
      return;
    }
    await refreshCartIcon();
  };

  // The COD-fee handler in cart-items.liquid clears the cart when every
  // remaining line is a fee, and only listens to on:line-item:change. Removing
  // the last real line here reaches that state without it, so it has to be told.
  // Guarded on a clean DOM so it cannot act on rows we have just removed.
  const notifyCartMutated = () => {
    if (collectKeysFromDom().length > 0) return;

    document.dispatchEvent(new CustomEvent('on:line-item:change', {
      bubbles: true,
      detail: { source: SOURCE }
    }));
  };

  const removeKeys = async (keys) => {
    const unique = [...new Set(keys)].filter(Boolean);
    if (unique.length === 0) return;

    const updates = {};
    unique.forEach((key) => { updates[key] = 0; });

    try {
      const endpoint = window.theme?.routes?.cartUpdate || '/cart/update.js';
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });

      if (response.ok) {
        await refresh();
        notifyCartMutated();
      } else {
        console.warn(`Not-buyable cart cleanup rejected by ${endpoint}:`, response.status);
      }
    } catch (error) {
      console.error('Failed to remove not-buyable items from cart:', error);
    }
  };

  if (Array.isArray(window.mxNotBuyableCartKeys) && window.mxNotBuyableCartKeys.length > 0) {
    removeKeys(window.mxNotBuyableCartKeys);
  }
}());
